import type { Prototype } from "../prototype-types";

export const matthewLeandresPrototypes: Prototype[] = [
  {
    id: "mle-signup-welcome",
    name: "Signup Welcome",
    path: "/mle/signup-welcome",
    description:
      "Delightful welcome animation that plays at the end of the retailer signup flow, greeting the user by name and recapping their key choices.",
    owner: "Matthew Leandres",
    createdAt: "2026-07-02",
    lastUpdated: "2026-07-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8255864aaa5abadb01914268679c3b7c8d95b7a09d14a5ca9309389385754d88.png",
    creationTool: "claude-code",
  },
  {
    id: "mle-personal-info-locked",
    name: "Personal Info – Locked After Account Creation",
    path: "/mle/personal-info-locked",
    description:
      "Variants of the personal-info signup step for when it&#39;s revisited after a pending retailer user account has already been created — password hidden, and other fields shown read-only.",
    owner: "Matthew Leandres",
    createdAt: "2026-07-07",
    lastUpdated: "2026-07-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2deb8a98dcf6830c21d586b621fc72e1ae2552a1ea8ff82d8e1d050209fd0ed7.png",
    creationTool: "claude-code",
  },
  {
    id: "mle-signup-granular-step-animations",
    name: "Signup Granular Step Animations",
    path: "/mle/signup-granular-step-animations",
    description:
      "Compare granular step-enter animation styles across representative signup layouts (desktop + mobile).",
    owner: "Matthew Leandres",
    createdAt: "2026-07-09",
    lastUpdated: "2026-07-13",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.faire.com/fastly/a8677a6f8abc050cd6077b91809bd8ea182a06844811ceaa8ce3b39a944b5a16.png",
  },
  {
    id: "mle-net-terms-transition-reveal",
    name: "Net Terms Transition Reveal",
    path: "/mle/net-terms-transition-reveal",
    description:
      "Replaces the button-spinner wait between Legal Business Name and Net Terms with a full transition screen (spinner, title, rotating subtitles) and a confetti celebration on reveal. Several variants of each, with hypothesis notes.",
    owner: "Matthew Leandres",
    createdAt: "2026-08-05",
    lastUpdated: "2026-08-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/97fe68c4cef8d0ad58fe40f5b6889655dd48d1c77018f906531cdd9871f2a4b2.png",
    creationTool: "claude-code",
  },
  {
    id: "mle-first-steps-3-brand-cart",
    name: "First steps — 3-brand cart",
    path: "/mle/first-steps-3-brand-cart",
    description:
      "In-session first-steps after the first add-to-cart: progress toward 3 brands, instead of a Setup Guide checklist task.",
    owner: "Matthew Leandres",
    createdAt: "2026-08-25",
    lastUpdated: "2026-08-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/mle-first-steps-3-brand-cart.png",
    creationTool: "claude-code",
  },
  {
    id: "mle-fd-personal-info-branding",
    name: "FD Personal Info Branding",
    path: "/mle/fd-personal-info-branding",
    description:
      "Treatments A (product strip), B (brand lockup), and C (avatar + strip) for Faire Direct personal-info chrome, with desktop and mobile.",
    owner: "Matthew Leandres",
    createdAt: "2026-10-08",
    lastUpdated: "2026-10-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bf3ac19bc2e67ba5ee797fbca51c70beb5715569e7fd7e5230a18c8a7b859264.webp",
    creationTool: "cursor",
  },
];
